// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2585Y","title":"InfoRow_title__2IYCL"};